define('BottomNoticeView',['backbone', 'jquery', 'notificationFx', 'app'], function (Backbone, $, NotificationFx, app) {

    var BottomNoticeView = Backbone.View.extend({
        initialize: function (text) {
            var view = this;
            app.trigger('updatePos');
            view.listenTo(app, 'updatePos', view.updatePos);
            view.render(text);
        },
        render: function(text){
            var view = this,
                wrapper = $('<div class="notification-shape shape-progress icon-logo-noborder" id="notification-shape"> <svg width="70px" height="70px"><path d="m35,2.5c17.955803,0 32.5,14.544199 32.5,32.5c0,17.955803 -14.544197,32.5 -32.5,32.5c-17.955803,0 -32.5,-14.544197 -32.5,-32.5c0,-17.955801 14.544197,-32.5 32.5,-32.5z"/></svg></div>');
            $('.page').append(wrapper);
            view.setElement(wrapper);

            view.notification = new NotificationFx({
                wrapper : this.el,
                message : '<p>'+ text +'</p>',
                layout : 'other',
                effect : 'loadingcircle',
                ttl : 5000,
                type : 'notice',
                onOpen : function() {
                    view.$el.addClass('active');
                },
                onClose : function() {
                    view.$el.removeClass('active');
                }
            });
            view.notification.show();
        },
        updatePos: function(){
            var view = this,
                el = view.$el,
                oldPos = parseInt(el.css('bottom')),
                newPos = oldPos + el.height() + 10;
            view.$el.css({bottom: newPos});
        }
    });
    
    return BottomNoticeView;
});
